import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./NfcPage.scss";
import Heart from "../../components/icons/Heart.jsx";
import NfcNavbar from "./components/navbar.component.jsx";

/* services */
import { getProfile } from "../../services/axiosService.js";
import NFCIntro from "../../components/nfc/NFCIntro.jsx";

export default function NfcPage() {
  /* artplacer script widget */
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://widget.artplacer.com/js/script.js";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      window.ArtPlacer.reload();
    };
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const navigate = useNavigate();

  /* image, number and metadata item */
  const [{ imageUrl, metadata }, setItem] = useState({});
  const { itemNumber } = useParams();

  /* get profile */
  useEffect(() => {
    const getProfileAsync = async () => {
      try {
        const formattedNumber = itemNumber.startsWith("0")
          ? itemNumber.slice(1)
          : itemNumber;

        const convertedNumber = Number(formattedNumber);
        if (!convertedNumber) {
          navigate("not-found");
        } else {
          const itemProfile = await getProfile(formattedNumber);
          setItem(itemProfile.data);
        }
      } catch (err) {
        console.error("err", err);
      }
    };
    getProfileAsync();
  }, [itemNumber]);

  const [activo, setActivo] = useState("");
  const handleSetActivo = (activo) => {
    setActivo(activo);
  };

  return (
    <div className="nfcPage">
      <NFCIntro />
      <div className="nfcContainer">
        <NfcNavbar itemNumber={itemNumber} />
        <div className="nfcTitlecontainer">
          <h1 className={`nfcTitle`}>#{itemNumber}</h1>
          <h1>
            <Heart size={55} fillColor="#fff" />
          </h1>
        </div>
        <div className={`nfcSubtitleContainer`}>
          <p className={`subtitle1`}>Esta es tu</p>
          <p className={`subtitle2`}>FANCY MONA</p>
        </div>
        <img className={`nfcImage`} src={imageUrl} alt="card" />
        <div className={`buttonsContainer`}>
          {/** widget */}
          <artplacer
            gallery="107182"
            unit="cm"
            type="3"
            data_capture_form="false"
            className={`btnArtplacer`}
            text="Ver en RA"
            artwork_url={`https://artbag-monas.s3.amazonaws.com/images/frames/fancy-mona-${itemNumber}.png`}
          ></artplacer>
          <a
            className={`downloadImage`}
            href={imageUrl}
            download={imageUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar
          </a>
        </div>
        <div className={`technicalCotainer`}>
          <h3 className={`technicalTitle`}>FICHA TÉCNICA</h3>
        </div>

        <div className="mt-4 accordionSite">
          <div className="accordion" id="miAcordeon">
            {/** soporte */}
            <div className={`accordion-item accordionItem`} id="accordion-one">
              <div className="accordion-header">
                <h2> Soporte</h2>
                <button
                  className={`accordion-button accordionButton ${
                    activo !== "one" ? "collapsed" : ""
                  }`}
                  onClick={() => handleSetActivo(activo === "one" ? "" : "one")}
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "one" ? "show" : ""
                }`}
              >
                <div>
                  <p>
                    Obra digital desarrollada mediante un algoritmo de
                    optimización combinatoria, impresa en papel Hahnemühle Photo
                    Rag 300 g/m² con marco blanco satinado estilo caja de 72,5 x
                    72,5 cm, realizado en madera Marupá con vidrio cristal.
                  </p>
                </div>
              </div>
            </div>

            {/** dimensiones */}
            <div className={`accordion-item accordionItem`} id="accordion-two">
              <div className="accordion-header">
                <h2>Dimensiones</h2>
                <button
                  className={`accordion-button accordionButton ${
                    activo !== "two" ? "collapsed" : ""
                  }`}
                  onClick={() => handleSetActivo(activo === "two" ? "" : "two")}
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "two" ? "show" : ""
                }`}
              >
                <div>
                  <p>72,5 x 72,5 cm</p>
                </div>
              </div>
            </div>

            {/** edición */}
            <div
              className={`accordion-item accordionItem`}
              id="accordion-three"
            >
              <div className="accordion-header">
                <h2>Edición</h2>
                <button
                  className={`accordion-button accordionButton ${
                    activo !== "three" ? "collapsed" : ""
                  }`}
                  onClick={() =>
                    handleSetActivo(activo === "three" ? "" : "three")
                  }
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "three" ? "show" : ""
                }`}
              >
                <div>
                  <p>1/1</p>
                </div>
              </div>
            </div>

            {/** metadata */}
            <div className={`accordion-item accordionItem`} id="accordion-four">
              <div className="accordion-header">
                <h2>Metadata</h2>
                <button
                  className={`accordion-button accordionButton ${
                    activo !== "four" ? "collapsed" : ""
                  }`}
                  onClick={() =>
                    handleSetActivo(activo === "four" ? "" : "four")
                  }
                ></button>
              </div>
              <div
                className={`accordion-collapse accordionCollapse collapse ${
                  activo === "four" ? "show" : ""
                }`}
              >
                <div>
                  {metadata && (
                    <>
                      <p>
                        Matriz de datos que utilizó el algoritmo para generar
                        las Fancy Monas. La colección comparte las categorías
                        pero cada obra tiene un perfil con valores único. Y
                        sumar los rasgos de cada mona en particular.
                      </p>
                      <div className="d-flex flex-wrap">
                        {Object.keys(metadata).map((key, index) => (
                          <div key={index} className={`metadata`}>
                            {key}: {metadata[key]}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
